import IGenericResult from "../interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class ClienteInstalacaoService {
    async update(data: any) {
        return await api.put<any>(`${resources.clienteInstalacao}/Update`, data);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.clienteInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getAllInstalacoesCliente() {
        return await api.get<IGenericResult[]>(`${resources.clienteInstalacao}/GetAllInstalacoesCliente`);
    }

    async getStatusSincronizacao() {
        return await api.get(`${resources.clienteInstalacao}/GetStatusSincronizacao`);
    }
    async delete(data: any) {
        return await api.put(`${resources.clienteInstalacao}/Delete`, data);
    }
    async restore(data: any) {
        return await api.put(`${resources.clienteInstalacao}/Restore`, data);
    }
    async getWithFilterHistorico(filters: any) {
        return await api.get<IPayload>(`${resources.clienteInstalacao}/GetWithFilterHistorico/${ToQueryString(filters)}`);
    }
}

export default new ClienteInstalacaoService();
